module.exports = __webpack_public_path__ + "img/hexagon_white_outlined_token.63fca75b.png";